export * from './ScanToPayFaqCta';
